import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const styles = theme => ({
	overlay: {
		padding: 24,
		//height: 'calc(100% - 48px)',
		overflow: 'auto',
	},
	contentToolbar: {
		background: `linear-gradient(to bottom, ${theme.palette.grey[300]} 200px,rgba(255,255,255,0) 200px,rgba(255,255,255,0) 100%)`,
		backgroundAttachment: 'scroll',
	},
});

function Content(props) {
	const { showToolbar, classes, className, ...parentProps} = props;

	return (
		<div
			{...parentProps}
			className={
				classNames(
					classes.overlay,
					showToolbar && (classes.contentToolbar),
					className && className
				)
			}

		>
			{props.children}
		</div>
	);
}


Content.defaultProps = {
	showToolbar: false,
};

Content.propTypes = {
	showToolbar: PropTypes.bool,
};


export default withStyles(styles)(Content);